import { CSSProperties } from "react"

type SortDirection = 'asc' | 'desc'

export type SortOptions = {
  sortBy: string,
  sortDir: SortDirection,
}

export enum Entity {
  CONTACT = 'CONTACT',
  SCHOOL = 'SCHOOL',
  DISTRICT = 'DISTRICT',
  AGENCY = 'AGENCY',
  DOMAIN = 'DOMAIN',
  INGESTION = 'INGESTION',
  RFP = 'RFP',
  SIGNAL = 'SIGNAL',
}

enum APIAction {
  EXPORT_CSV = 'EXPORT_CSV'
}

export enum FieldName {
  ID = 'id',
  NAME = 'name',
  TYPE = 'type',
  FSCL_REV_TOTAL = 'fsclRevTotal',
  STUDENTS_TOTAL = 'studentsTotal',
  TOTAL_SCHOOLS = 'totalSchools',
  TOTAL_DISTRICTS = 'totalDistricts',
  LOC_STATE = 'locState',
  WEBSITE = 'website',
  ACCESS = 'access',
  SUBTYPE = 'subtype',
  TITLE_ONE = 'titleOne',
  GRADE_SPAN = 'gradeSpan',
  DS_FSCL_REV_TOTAL = 'dsFsclRevTotal',
  TITLE = 'title',
  BIO = 'bio',
  EMAIL = 'email',
  PHONE = 'phone',
  NR_INSTITUTIONS = 'nrInstitutions',
  NR_IMPORTANT_URLS = 'nrImportantUrls',
  NR_LINKED_DOMAINS = 'nrLinkedDomains',
  DOMAIN = 'domain',
  INGESTED_AT = 'ingestedAt',
  HREF = 'href',
  LOCATION = 'geo',
  NEARBY_INSTITUTIONS = 'nearbyInstitutions',
  BROWSER_NAME = 'browserName',
  OS_NAME = 'osName',
  VENDOR_NAME = 'vendor_name',
  DATE_CONTRACT_END = 'date_contract_end',
  DATE_CONTRACT_EFFECTIVE = 'date_contract_effective',
  DESCRIPTION = 'description',
  INSTITUTION_NAME = 'institution_name',
  CONTRACT_DURATION = 'contract_duration',
}

type FieldProps = {
  label: string
}

export const FieldConfig: { [key: string]: FieldProps } = {
  [FieldName.NAME]: {
    label: 'Name',
  },
  [FieldName.TYPE]: {
    label: 'Type',
  },
  [FieldName.FSCL_REV_TOTAL]: {
    label: 'Annual Revenue',
  },
  [FieldName.STUDENTS_TOTAL]: {
    label: 'Nr. of Students',
  },
  [FieldName.TOTAL_SCHOOLS]: {
    label: 'Child Inst.',
  },
  [FieldName.TOTAL_DISTRICTS]: {
    label: 'Nr. of Institutions',
  },
  [FieldName.LOC_STATE]: {
    label: 'State',
  },
  [FieldName.WEBSITE]: {
    label: 'Website',
  },
  [FieldName.ACCESS]: {
    label: 'Access',
  },
  [FieldName.SUBTYPE]: {
    label: 'Subtype',
  },
  [FieldName.TITLE_ONE]: {
    label: 'Title I',
  },
  [FieldName.GRADE_SPAN]: {
    label: 'District Grade',
  },
  [FieldName.DS_FSCL_REV_TOTAL]: {
    label: 'Annual Revenue',
  },
  [FieldName.TITLE]: {
    label: 'Title',
  },
  [FieldName.BIO]: {
    label: 'Bio',
  },
  [FieldName.EMAIL]: {
    label: 'Email',
  },
  [FieldName.PHONE]: {
    label: 'Phone',
  },
  [FieldName.ID]: {
    label: 'Domain',
  },
  [FieldName.NR_INSTITUTIONS]: {
    label: 'Nr. of Institutions',
  },
  [FieldName.NR_IMPORTANT_URLS]: {
    label: 'Nr. of Important URLs',
  },
  [FieldName.NR_LINKED_DOMAINS]: {
    label: 'Nr. of Linked Domains',
  },
  [FieldName.INGESTED_AT]: {
    label: 'Date',
  },
  [FieldName.LOCATION]: {
    label: 'Location',
  },
  [FieldName.HREF]: {
    label: 'URL',
  },
  [FieldName.NEARBY_INSTITUTIONS]: {
    label: 'Nearby Districts',
  },
  [FieldName.DOMAIN]: {
    label: 'Domain',
  },
  [FieldName.BROWSER_NAME]: {
    label: 'Browser',
  },
  [FieldName.OS_NAME]: {
    label: 'OS',
  },
  [FieldName.INSTITUTION_NAME]: {
    label: 'Institution',
  },
  [FieldName.VENDOR_NAME]: {
    label: 'Vendor',
  },
  [FieldName.DESCRIPTION]: {
    label: 'Description',
  },
  [FieldName.DATE_CONTRACT_END]: {
    label: 'End Date',
  },
  [FieldName.DATE_CONTRACT_EFFECTIVE]: {
    label: 'Effective Date',
  },
  [FieldName.CONTRACT_DURATION]: {
    label: 'Contract Length',
  }
}

export type FieldOption = {
  fieldName: FieldName
  isVisibleByDefault: boolean
  isHideable: boolean,
  isSortable: boolean,
  style?: CSSProperties
}

export const ColumnVisibilityPrefix = 'IS_COLUMN_VISIBLE'

export interface Box {
  x: number
  y: number
  width: number
  height: number
}

interface BoundingBox {
  meta: {
    value: string
    type: string
  }
  boxes: Box[]
}

export interface ScreenshotSize {
  width: number
  height: number
}

export interface UrlVersion {
  screenshot: string
  screenshot_size: ScreenshotSize
  boxes: BoundingBox[]
}